document.addEventListener("DOMContentLoaded", function() {
  // Function to format numbers with commas
  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  // Select all elements with the class `product-count`
  var productCountElements = document.querySelectorAll('.product-count');

  // Loop through all the elements and format their text content
  productCountElements.forEach(function(element) {
    var count = element.textContent.trim();
    element.textContent = numberWithCommas(count);
  });
});